
import { IConditionsProps, IInfoProps, ISortProps } from './interface'

export const sort = [
  { key: 'sort', text: '热度最高', param: 'hot' },
  { key: 'sort', text: '价格由高到低', param: 'price_dec' },
  { key: 'sort', text: '价格由低到高', param: 'price_asc' }
]

// ["0 价格", "1 级别", "2 国别", "3 变速箱", "4 结构", "5 排量", "6 能源", "7 座位数", "8 驱动方式", "9 安全配置", "10 舒适配置", "11 懂车分", "12 车系细分" 13 气缸数 14进气方式]
export const conditions: IConditionsProps[] = [
  {
    "template": 'single',
    "title": "价格",
    "data": [
      {
        "param": "x",
        "text": "不限",
        "key": "price"
      },
      {
        "param": "0,10",
        "text": "10万以下",
        "key": "price"
      },
      {
        "param": "10,15",
        "text": "10-15万",
        "key": "price"
      },
      {
        "param": "15,20",
        "text": "15-20万",
        "key": "price"
      },
      {
        "param": "20,25",
        "text": "20-25万",
        "key": "price"
      },
      {
        "param": "25,30",
        "text": "25-30万",
        "key": "price"
      },
      {
        "param": "30,40",
        "text": "30-40万",
        "key": "price"
      },
      {
        "param": "50,-1",
        "text": "50万以上",
        "key": "price"
      },
      {
        "param": "",
        "text": "输入框",
        "key": "price"
      },
    ]
  },
  {
    "template": 'car',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "轿车",
        "key": "series_type",
        "param": 0,
      },
      {
        "text": "SUV",
        "key": "series_type",
        "param": 1,
      },
      {
        "text": "MPV",
        "key": "series_type",
        "param": 2,
      },
      {
        "text": "跑车",
        "key": "series_type",
        "param": 4,
      },
      {
        "text": "皮卡",
        "key": "series_type",
        "param": 3
      },
      {
        "text": "微面",
        "key": "series_type",
        "param": 7,
      },
      {
        "text": "微卡",
        "key": "series_type",
        "param": 8,
      },
      {
        "text": "轻客",
        "key": "series_type",
        "param": 6,
      },
      {
        "text": "卡车",
        "key": "series_type",
        "param": '13,8,3',
      },
      {
        "param": "13",
        "text": "轻卡",
        "key": "series_type"
      },
    ],
    "title": "级别"
  },
  {
    "template": 'single',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "中国",
        "key": "country",
        "param": 0
      },
      {
        "text": "德国",
        "key": "country",
        "param": 3
      },
      {
        "text": "日本",
        "key": "country",
        "param": 1
      },
      {
        "text": "美国",
        "key": "country",
        "param": 2
      },
      {
        "text": "韩国",
        "key": "country",
        "param": 4
      },
      {
        "text": "法国",
        "key": "country",
        "param": 5
      },
      {
        "text": "其他",
        "key": "country",
        "param": '9,11,7'
      }
    ],
    "title": "国别"
  },
  {
    "template": 'hover-single',
    "data": [
      {
        "text": "手动",
        "key": "gearbox_type",
        "param": 1
      },
      {
        "text": "自动",
        "key": "gearbox_type",
        "param": 2
      }
    ],
    "title": "变速箱"
  },
  {
    "template": 'single',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "两厢",
        "key": "body_detail_type",
        "param": 0
      },
      {
        "text": "三厢",
        "key": "body_detail_type",
        "param": 1
      },
      {
        "text": "掀背",
        "key": "body_detail_type",
        "param": 3
      },
      {
        "text": "硬顶敞篷",
        "key": "body_detail_type",
        "param": 5
      },
      {
        "text": "软顶敞篷",
        "key": "body_detail_type",
        "param": 6
      },
      {
        "text": "硬顶跑车",
        "key": "body_detail_type",
        "param": 4
      },
      {
        "text": "旅行版",
        "key": "body_detail_type",
        "param": 2
      }
    ],
    "title": "结构"
  },
  {
    "template": 'hover-single',
    "data": [
      {
        "text": "1.0及以下",
        "key": "capacity_l",
        "param": "0~1.0"
      },
      {
        "text": "1.1-1.6L",
        "key": "capacity_l",
        "param": "1.1~1.6"
      },
      {
        "text": "1.7-2.0L",
        "key": "capacity_l",
        "param": "1.7~2.0"
      },
      {
        "text": "2.1-2.5L",
        "key": "capacity_l",
        "param": "2.1~2.5"
      },
      {
        "text": "2.6-3.0L",
        "key": "capacity_l",
        "param": "2.6~3.0"
      },
      {
        "text": "3.1-4.0L",
        "key": "capacity_l",
        "param": "3.1~4.0"
      },
      {
        "text": "4.0L以上",
        "key": "capacity_l",
        "param": "4.0~-1"
      }
    ],
    "title": "排量"
  },
  {
    "template": 'fuel_form',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "汽油",
        "key": "fuel_form",
        "param": 1
      },
      {
        "text": "柴油",
        "key": "fuel_form",
        "param": 2
      },
      {
        "text": "纯电动",
        "key": "fuel_form",
        "param": 4
      },
      {
        "text": "油电混合",
        "key": "fuel_form",
        "param": 3
      },
      {
        "text": "增程式",
        "key": "fuel_form",
        "param": 5
      },
      {
        "text": "插电式混合动力",
        "key": "fuel_form",
        "param": 6
      },
      {
        "text": "新能源",
        "key": "fuel_form",
        "param": '4,5,6',
      },
      {
        "text": "汽油+48V轻混系统",
        "key": "fuel_form",
        "param": 13
      },
    ],
    "title": "能源"
  },
  {
    "template": 'single',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "2座",
        "key": "seat_count",
        "param": 2
      },
      {
        "text": "4座",
        "key": "seat_count",
        "param": 4
      },
      {
        "text": "5座",
        "key": "seat_count",
        "param": 5
      },
      {
        "text": "6座",
        "key": "seat_count",
        "param": 6
      },
      {
        "text": "7座",
        "key": "seat_count",
        "param": 7
      },
      {
        "text": "7座以上",
        "key": "seat_count",
        "param": "-1"
      }
    ],
    "title": "座位数"
  },
  {
    "template": 'hover-single',
    "data": [
      {
        "text": "前驱",
        "key": "driven_form",
        "param": 1
      },
      {
        "text": "后驱",
        "key": "driven_form",
        "param": 2
      },
      {
        "text": "四驱",
        "key": "driven_form",
        "param": 3
      }
    ],
    "title": "驱动方式"
  },
  {
    "template": 'hover-select',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "氙气大灯",
        "key": "xenon_lamp",
        "param": 1
      },
      {
        "text": "车身稳定系统",
        "key": "body_stability_system",
        "param": 1
      },
      {
        "text": "倒车雷达",
        "key": "parking_radar",
        "param": 1
      },
      {
        "text": "自动泊车",
        "key": "auto_park_entry",
        "param": 1
      },
      {
        "text": "儿童座椅接口",
        "key": "child_seat_interface",
        "param": 1
      },
      {
        "text": "倒车影像",
        "key": "reversing_camera",
        "param": 1
      },
      {
        "text": "日间行车灯",
        "key": "daytime_light",
        "param": 1
      }
    ],
    "title": "安全配置"
  },
  {
    "template": 'hover-select',
    "data": [
      {
        "text": "不限",
        "key": "",
        "param": "x"
      },
      {
        "text": "全景天窗",
        "key": "panoramic_skylight",
        "param": 1
      },
      {
        "text": "定速巡航",
        "key": "cruise",
        "param": 1
      },
      {
        "text": "多功能方向盘",
        "key": "multifunction_steer_wheel",
        "param": 1
      },
      {
        "text": "无钥匙启动",
        "key": "keyless_start",
        "param": 1
      },
      {
        "text": "座椅加热",
        "key": "front_and_rear_seat_heating",
        "param": 1
      },
      {
        "text": "电动座椅",
        "key": "electric_seat_memory",
        "param": 1
      },
      {
        "text": "自适应巡航",
        "key": "adaptive_cruise",
        "param": 1
      },
      {
        "text": "GPS导航",
        "key": "gps",
        "param": 1
      }
    ],
    "title": "舒适配置"
  },
  {
    "template": 'single',
    "title": "懂车分",
    "data": [
      {
        "param": "x",
        "text": "不限",
        "key": "dcar_score"
      },
      {
        "param": "0,3",
        "text": "3.0分以下",
        "key": "dcar_score"
      },
      {
        "param": "3,3.5",
        "text": "3.0-3.5分",
        "key": "dcar_score"
      },
      {
        "param": "3.5,4",
        "text": "3.5-4.0分",
        "key": "dcar_score"
      },
      {
        "param": "4,4.5",
        "text": "4.0-4.5分",
        "key": "dcar_score"
      },
      {
        "param": "4.5,5",
        "text": "4.5-5分",
        "key": "dcar_score"
      },
      {
        "param": "",
        "text": "输入框",
        "key": "dcar_score"
      },
    ]
  },
  {
    "template": 'none',
    "title": "车系细分",
    "data": [
      {
        "param": "0",
        "text": "微型车",
        "key": "outter_detail_type"
      },
      {
        "param": "1",
        "text": "小型车",
        "key": "outter_detail_type"
      },
      {
        "param": "2",
        "text": "紧凑型车",
        "key": "outter_detail_type"
      },
      {
        "param": "3",
        "text": "中型车",
        "key": "outter_detail_type"
      },
      {
        "param": "4",
        "text": "中大型车",
        "key": "outter_detail_type"
      },
      {
        "param": "5",
        "text": "大型车",
        "key": "outter_detail_type"
      },
      {
        "param": "10",
        "text": "小型SUV",
        "key": "outter_detail_type"
      },
      {
        "param": "11",
        "text": "紧凑型SUV",
        "key": "outter_detail_type"
      },
      {
        "param": "12",
        "text": "中型SUV",
        "key": "outter_detail_type"
      },
      {
        "param": "13",
        "text": "中大型SUV",
        "key": "outter_detail_type"
      },
      {
        "param": "14",
        "text": "大型SUV",
        "key": "outter_detail_type"
      },
      {
        "param": "20",
        "text": "小型MPV",
        "key": "outter_detail_type"
      },
      {
        "param": "21",
        "text": "紧凑型MPV",
        "key": "outter_detail_type"
      },
      {
        "param": "22",
        "text": "中型MPV",
        "key": "outter_detail_type"
      },
      {
        "param": "23",
        "text": "大型MPV",
        "key": "outter_detail_type"
      },
      {
        "param": "30",
        "text": "迷你皮卡",
        "key": "outter_detail_type"
      },
      {
        "param": "31",
        "text": "中型皮卡",
        "key": "outter_detail_type"
      },
      {
        "param": "32",
        "text": "全尺寸皮卡",
        "key": "outter_detail_type"
      },
      {
        "param": "33",
        "text": "重型皮卡",
        "key": "outter_detail_type"
      },
      {
        "param": "34",
        "text": "超重型皮卡",
        "key": "outter_detail_type"
      },
    ]
  },
  {
    "template": 'hover-single',
    "title": "气缸数",
    "data": [
      {
        "param": "3",
        "text": "3缸",
        "key": "cylinder_nums"
      },
      {
        "param": "4",
        "text": "4缸",
        "key": "cylinder_nums"
      },
      {
        "param": "5",
        "text": "5缸",
        "key": "cylinder_nums"
      },
      {
        "param": "6",
        "text": "6缸",
        "key": "cylinder_nums"
      },
      {
        "param": "8",
        "text": "8缸",
        "key": "cylinder_nums"
      },
      {
        "param": "-1",
        "text": "8缸以上",
        "key": "cylinder_nums"
      },
    ]
  },
  {
    "template": 'hover-single',
    "title": "进气方式",
    "data": [
      {
        "param": "1",
        "text": "自然吸气",
        "key": "gas_form"
      },
      {
        "param": "3,4,5,6,7",
        "text": "涡轮增压",
        "key": "gas_form"
      },
      {
        "param": "2",
        "text": "机械增压",
        "key": "gas_form"
      },
    ]
  },
];

export default conditions